import type { SearchCarResult } from '$lib/components/search/cars/types';
import { track } from '$lib/services/tracking/googleAnalytics';

export function trackSaveCar(detail: string | undefined, selectedCar: SearchCarResult | null) {
	const car = selectedCar?.options.find(option => option.carId === detail);
	track({
		action: 'car_fill_finish',
		payload: {
			action: 'save',
			car_id: detail,
			car_name: selectedCar?.fullname,
			car_year: car?.constructionYears,
			car_gastype: car?.energy,
			car_motorization: car?.motor,
		},
	});
}
